export const
    INFO_NOTIFICATION = "INFO_NOTIFICATION",
    SUCCESS_NOTIFICATION = "SUCCESS_NOTIFICATION",
    WARNING_NOTIFICATION = "WARNING_NOTIFICATION";


// WEBPACK FOOTER //
// ./src/const/Notifications.js